// step 3 of the sponsor pledge flow

import React from 'react'
import Icon from '../../../../components/icon'
import { ensureAbsoluteUrl } from '../../../../utils/url'
import { formatPhoneInput } from '../sponsorPledgeFormat'

export default function Step3Information({
  styles,
  t,
  fieldErrors,
  bizName,
  setBizName,
  contactName,
  setContactName,
  bizEmail,
  setBizEmail,
  bizPhone,
  setBizPhone,
  bizWeb,
  setBizWeb,
  validateStep3,
  setStep,
}) {
  return (
    <>
      <h1 className={styles.stepHeading}>
        {t('sponsorPledgeFlow.step3.heading')}
      </h1>
      <p className={styles.stepSubheading}>
        {t('sponsorPledgeFlow.step3.subheading')}
      </p>

      <div className={styles.sectionLabel}>
        {t('sponsorPledgeFlow.step3.sectionContact')}
      </div>
      <div className={styles.inputRow}>
        <div>
          <label className={styles.crLabel} htmlFor="sp-biz-name">
            {t('sponsorPledgeFlow.step3.businessName')}
            <span className={styles.crRequired}>*</span>
          </label>
          <input
            id="sp-biz-name"
            className={`${styles.crInput} ${
              fieldErrors.bizName ? styles.crInputError : ''
            }`}
            value={bizName}
            onChange={e => setBizName(e.target.value)}
          />
          {fieldErrors.bizName ? (
            <div className={styles.errorMsg}>
              {t('sponsorPledgeFlow.step3.errBusinessName')}
            </div>
          ) : null}
        </div>
        <div>
          <label className={styles.crLabel} htmlFor="sp-contact">
            {t('sponsorPledgeFlow.step3.contactName')}
            <span className={styles.crRequired}>*</span>
          </label>
          <input
            id="sp-contact"
            className={`${styles.crInput} ${
              fieldErrors.contactName ? styles.crInputError : ''
            }`}
            value={contactName}
            onChange={e => setContactName(e.target.value)}
          />
          {fieldErrors.contactName ? (
            <div className={styles.errorMsg}>
              {t('sponsorPledgeFlow.step3.errContactName')}
            </div>
          ) : null}
        </div>
      </div>

      <div className={styles.inputRow}>
        <div>
          <label className={styles.crLabel} htmlFor="sp-email">
            {t('sponsorPledgeFlow.step3.email')}
            <span className={styles.crRequired}>*</span>
          </label>
          <input
            id="sp-email"
            className={`${styles.crInput} ${
              fieldErrors.bizEmail ? styles.crInputError : ''
            }`}
            type="email"
            value={bizEmail}
            onChange={e => setBizEmail(e.target.value)}
          />
          {fieldErrors.bizEmail ? (
            <div className={styles.errorMsg}>
              {t('sponsorPledgeFlow.step3.errEmail')}
            </div>
          ) : null}
        </div>
        <div>
          <label className={styles.crLabel} htmlFor="sp-phone">
            {t('sponsorPledgeFlow.step3.phone')}
            <span className={styles.crRequired}>*</span>
          </label>
          <input
            id="sp-phone"
            className={`${styles.crInput} ${
              fieldErrors.bizPhone ? styles.crInputError : ''
            }`}
            value={bizPhone}
            onChange={e => setBizPhone(formatPhoneInput(e.target.value))}
          />
          {fieldErrors.bizPhone ? (
            <div className={styles.errorMsg}>
              {t('sponsorPledgeFlow.step3.errPhone')}
            </div>
          ) : null}
        </div>
      </div>

      <div>
        <label className={styles.crLabel} htmlFor="sp-web">
          {t('sponsorPledgeFlow.step3.website')}{' '}
          <span
            style={{ fontSize: 12, color: 'var(--light)', fontWeight: 400 }}
          >
            ({t('sponsorPledgeFlow.optional')})
          </span>
        </label>
        <input
          id="sp-web"
          className={`${styles.crInput} ${
            fieldErrors.bizWeb ? styles.crInputError : ''
          }`}
          value={bizWeb}
          onChange={e => setBizWeb(e.target.value)}
          onBlur={() => {
            const trimmed = bizWeb.trim()
            if (trimmed && !/^https?:\/\//i.test(trimmed)) {
              setBizWeb(ensureAbsoluteUrl(bizWeb))
            }
          }}
        />
        {fieldErrors.bizWeb ? (
          <div className={styles.errorMsg}>
            {t('sponsorPledgeFlow.step3.errWebsite')}
          </div>
        ) : null}
      </div>

      <div className={styles.stepNav}>
        <button
          type="button"
          className={styles.btnBack}
          onClick={() => setStep(2)}
        >
          ‹ {t('buttons.back')}
        </button>
        <button
          type="button"
          className={styles.btnPrimary}
          onClick={validateStep3}
        >
          {t('buttons.continue')}
          <Icon name="chevron-right" />
        </button>
      </div>
    </>
  )
}
